import React from 'react';
import ProgressAccordion from '@/components/ProgressAccordion/ProgressAccordion';
import { I18nSupport } from '@/utils/types';
import { Col, ComponentWithProps, Container, Row } from '@visalex/core';

import cx from 'clsx';
import { useTranslation } from 'next-i18next';

import styles from './HowItWorks.module.scss';

const HowItWorks: ComponentWithProps<I18nSupport> = ({ className, i18nPrefix }) => {
  const { t } = useTranslation();

  return (
    <section className={cx(className, styles['how-it-works'])}>
      <Container>
        <Row>
          <Col xs={12}>
            <h3 className="text-lg-center">{t(`${i18nPrefix}.intro.how-it-works`)}</h3>
            <ProgressAccordion i18nPrefix={i18nPrefix} />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HowItWorks;
